const tenant = [{
  path: '/bookings',
  name: 'Tenants.Bookings.List',
  component: () => import(/* webpackChunkName: "bookings" */ '@/views/tenant/Bookings.vue')
}]

export default tenant